// extracted by mini-css-extract-plugin
export default {"root":"_3ISPBjHC","content":"_15yqqiRH","placeholder":"_3VpReIeK"};